import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme, $centered }) => css`
    background: linear-gradient(270deg,
      ${theme.v2.colors.brand.primaryUltraLight} 0%,
      ${theme.v2.colors.neutral.highPure} 15%,
      ${theme.v2.colors.neutral.highPure} 85%,
      ${theme.v2.colors.brand.primaryUltraLight} 100%
    );
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: ${$centered ? 'center' : 'flex-start'};
    height: 100%;
    min-height: 100%;
  `}
`;

export const LogoRow = styled.div`
  ${({ theme }) => css`
    align-items: center;
    background: ${theme.v2.colors.white.primary};
    border-bottom: 1px solid ${theme.v2.colors.brand.primaryLowLight};
    box-sizing: border-box;
    display: flex;
    height: 82px;
    justify-content: center;
    margin: 0 auto;
    position: relative;
    width: 100%;
    z-index: 10;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 82px;
    }

    > button {
      position:absolute;
      right: 32px;
    }
  `}
`;

export const Container = styled.div`
  ${({ theme }) => css`
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    height: calc(100% - 82px);

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: calc(100% - 82px);
    }
  `}
`;
